import TooltipWrapper from './TooltipWrapper';

export function TranscriptCheckbox( props ) {
	if ( ! props.post.acf.transcript_file ) {
		return;
	}
	// We should be reusing the Checkbox component here
	return (
		<span className="employee-comms-transcript">
			<span className="employee-comms-checkbox--wrapper d-flex me-2">
				<input
					type="checkbox"
					id={'transcript-' + props.post.id}
					value={props.post.acf.transcript_file}
					className="multi-transcript-check employee-comms-checkbox"
				/>
				<label htmlFor={'transcript-' + props.post.id}>Add transcript</label>
			</span>

			<TooltipWrapper
				tooltipId={'transcript-' + props.post.id + '-tooltip'}
				tooltipContent={props.post.acf.transcript_tooltip}
			/>
		</span>

	);
}
export default TranscriptCheckbox;
